/**
 * 记录用户的访问记录栈
 * https://data-track-sgp.corp.kuaishou.com/#/docs/import?appName=TRINITY&model.currentPage=1&model.pageSize=10&groupId=7874&model.pageType=0&model.bizName=GENERAL&tagModel.currentPage=1&tagModel.pageSize=10&viewMode=SIMPLE&groupName=20230522-c%E7%AB%AF%E9%93%BE%E8%B7%AF%E4%B8%8A%E6%8A%A5
 * https://docs.corp.kuaishou.com/d/home/fcADqmyaXZgrr29EwPVIQSbi5
 */

import yoda from '@kibt/bridge';
import { radar } from '../log';

// 文档 https://docs.corp.kuaishou.com/d/home/fcAABwGVq_VxEw5SkgPIobPLT
export const DataTraceStackEnums = {
    // path: value
    // 我的订单页面
    OrderList: 214,
    // 电商直播间的小黄车列表
    ShoppingCar: 215,
    // 半屏商详页 216
    // 全屏商详页 217 在页面中单独处理
    // '/shop/c/pay-center/order-detail': 217,
    // 确认订单页
    OrderConfirm: 218,
    //  店铺页-全部商品 219
    //  商铺页-全部商品 220 在页面中单独处理
    // '/shop/c/merchant': 219/220
    //  支付成功页
    PayResult: 221,
    // 售后详情页
    AfterSaleDetail: 222,
    // P页商品tab
    MerchantProfile: 223,
    // 订单详情页
    OrderDetail: 224,
    // 优惠券
    Coupon: 227,
    // 地址管理
    AddressList: 228,
    // 优惠券适用商品列表
    CouponRecoList: 230,
    // 购物车
    MyShoppingCart: 238,
};

// https://docs.corp.kuaishou.com/d/home/fcADCc4SOIevfpDM-NQ1CXH0Z#section=h.c4dm9owd0c5z

// 这里的页面有关末次归因逻辑，所以需要在页面中单独加数据上报逻辑
// 这些页面需要携带额外参数，在组件的 beforeRouteLeave 单独处理逻辑
export const ECommerceLevelOneEntranceEnums = {
    // 店铺页-全部商品页（4） 或者 商铺页-达人橱窗（10），需要在页面里进行判断
    Merchant: 4,
    // 商详页-店铺推荐
    Detail: 5,
    // 订单列表页 - 猜你喜欢
    OrderList: 8,
    // 订单详情页
    OrderDetail: 9,
    // P页商品tab
    MerchantProfile: 11,
};

/**
 *  获取客户端中保存的当前webview的数据栈
 *  https://docs.corp.kuaishou.com/d/home/fcADqmyaXZgrr29EwPVIQSbi5
 */

interface DataTrace {
    message: string;
    businessCode: number;
    info: {
        // 页面名字，page_name缩写 枚举值
        pname: number;
        // 资源名字， resouce_type缩写(原media_source)
        rtype: string;
        // 资源id，resource_id缩写(原media_id)
        rid: string;
        // 场景id，原dedia_detail_source，短视频场景为exptag，直播场景为live_source
        rscene: string;
        // 数组item唯一标识id, 备用
        identity: string;
        innerPageInfos: {
            pname: number;
            // 资源名字， resouce_type缩写(原media_source)
            rtype: string;
            // 资源id，resource_id缩写(原media_id)
            rid: string;
            // 场景id，原dedia_detail_source，短视频场景为exptag，直播场景为live_source
            rscene: string;
            // 数组item唯一标识id, 备用
            identity: string;
        }[];
    };
}

export async function getCurrentDataTrace(args: {
    //客户端容器的identity标识
    appointIdentity?: string;
}): Promise<DataTrace> {
    try {
        return (await yoda.component.readCurrentPageStackInfo(args)) as any;
    } catch (e) {
        console.log('readCurrentPageStackInfo err', e);
        return { infos: [] } as any;
    }
}

/**
 * 客户端中保存的当前webview的数据栈，往里面写入数据
 */
export async function setPageDataTrace(info: {
    // 页面名字，page_name缩写 枚举值
    pname: number;
    // 资源名字， resouce_type缩写(原media_source)
    rtype?: any;
    // 资源id，resource_id缩写(原media_id)
    rid?: string | number;
    // 场景id，原dedia_detail_source，短视频场景为exptag，直播场景为live_source
    rscene?: any;
    identity?: any;
}) {
    try {
        const page = await getCurrentDataTrace({});
        info.identity = page?.info?.identity;
        page.info?.innerPageInfos?.push(info as any);
        const res = await yoda.component.writeCurrentPageStackInfo(page.info);
        return res;
    } catch (e) {
        console.log('writeCurrentPageStackInfo err', e);
    }
}

/**
 * 获取全链路数据栈
 */

export async function getAllLinkTrace(): Promise<{
    message: string;
    businessCode: number;
    infos: {
        rtype: string;
        rscene: string;
        rid: string;
        pname: number;
        identity: string;
        innerPageInfos: {
            items: {
                rtype: string;
                rscene: string;
                rid: string;
                pname: number;
                identity: string;
            };
        }[];
    }[];
}> {
    try {
        const res = await yoda.component.getAllPageStackInfo();
        if (res?.infos?.length > 10) {
            res.infos = [...res.infos.slice(0, 5), ...res.infos.slice(res.infos.length - 5, res.infos.length)];
        }
        radar.event({
            name: 'DetailStackInfo',
            params: {
                stackInfo: JSON.stringify(res),
            },
        });
        return res;
    } catch (e) {
        console.log('getAllPageStackInfo err', e);
        return { infos: [] } as any;
    }
}
